import React from 'react';
import { Helmet } from 'react-helmet';

interface SEO {
  Title: string;
  MetaDescription: string;
  MetaKeywords: string;
  MetaImage: string;
}

interface GA {
  Remarks: string;
  Location: string;
  Code: string;
}

interface SnAProps {
  seo: SEO;
  ga: GA[];
}

const RenderSnA: React.FC<SnAProps> = ({ seo, ga }) => {
  React.useEffect(() => {
    if (ga && ga.length > 0) {
      ga.forEach((item) => {
        if (item.Code) {
          if (item.Location === 'head') {
            document.head.insertAdjacentHTML('beforeend', item.Code);
          } else {
            document.body.insertAdjacentHTML('afterbegin', item.Code);
          }
        }
      });
    }
  }, [ga]);

  return (
    <>
      {seo && (
        <Helmet>
          {/* Character encoding */}
          <meta charSet="UTF-8" />
          {/* Viewport settings */}
          <meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no" />
          {/* Basic meta */}
          <title>{seo.Title ? `${seo.Title} | Now TV` : 'Now TV'}</title>
          <meta name="description" content={seo.MetaDescription || "Welcome to Now TV"} />
          <meta name="keywords" content={seo.MetaKeywords || "Now TV"} />
          {/* OpenGraph */}
          <meta property="og:title" content={seo.Title ? `${seo.Title} | Now TV` : 'Now TV'} />
          <meta property="og:url" content={window.location.href} />
          <meta property="og:description" content={seo.MetaDescription || "Welcome to Now TV"} />
          <meta property="og:image" content={seo.MetaImage || ""} />
          <meta property="og:image:width" content={seo.MetaImage ? "1200" : ""} />
          <meta property="og:image:height" content={seo.MetaImage ? "630" : ""} />

          <meta property="og:type" content="website" />
          <meta property="og:site_name" content="Now TV" />

          <meta name="robots" content="index, follow" />
          <meta name="googlebot" content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1" />
          <meta name="bingbot" content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1" />
          <meta name="canonical" content={window.location.href} />
          {/* Twitter Card */}
          <meta name="twitter:card" content="summary" />
          <meta name="twitter:title" content={seo.Title ? `${seo.Title} | Now TV` : 'Now TV'} />
          <meta name="twitter:description" content={seo.MetaDescription || "Welcome to Now TV"} />
          <meta name="twitter:image" content={seo.MetaImage || ""} />
        </Helmet>
      )}
    </>
  );
};

export default RenderSnA;